export const isLocalSnapshot = process.env.VUE_APP_LOCAL_SNAPSHOT === 'true';
export const nakaApiBaseUrl = (process.env.VUE_APP_NAKA_API_BASE_URL || 'https://api.thenakamotos.club').replace(/\/$/, '');
export const espoRpcUrl = process.env.VUE_APP_ESPO_RPC_URL || (isLocalSnapshot ? '/espo-rpc' : '');
export const espoExplorerUrl = (process.env.VUE_APP_ESPO_EXPLORER_URL || 'http://88.99.51.244:8083').replace(/\/$/, '');
